import { gql } from '@apollo/client';

export const ChartsTopLabelsQuery = gql`
    query ChartsTopLabels {
        chartsTopLabels {
            items {
                guid
                slug
                name
                artworkUrl
                lastRank
                currentRank
                isNew
                subItemsCount
                artistName
            }
        }
    }
`;

export const ChartsTopPacksQuery = gql`
    query ChartsTopPacks {
        chartsTopPacks {
            items {
                guid
                slug
                name
                artworkUrl
                lastRank
                currentRank
                isNew
                subItemsCount
                artistName
            }
        }
    }
`;

export const ChartsTopLandrPacksQuery = gql`
    query ChartsTopLandrPacks {
        chartsTopLandrPacks {
            items {
                guid
                slug
                name
                artworkUrl
                lastRank
                currentRank
                isNew
                subItemsCount
                artistName
            }
        }
    }
`;
